<template>
	<!-- eslint-disable vue/no-v-html -->
	<div
		class="vqb-group card mt-1 mb-1"
		:class="'depth-' + depth.toString()"
	>
		<div class=" card-header">
			<div class="match-type-container">
				<b-row align="top" align-v="center">

					<b-col cols="3" sm="3">

						<b-form-radio-group size="sm" v-model="query.logicalOperator" :options="labels.matchTypes" text-field="label" value-field="id"/>

					</b-col>

					<b-col cols="7" sm="7">

						<v-select ref="attr_select" :clearable="false" v-model="selectedRule" size="sm" :options="visible_rules" :getOptionKey="rule => rule.id" :getOptionLabel="rule => rule.label" style="background-color: white" />

					</b-col>

					<b-col cols="2" sm align="right">

						<b-button class="filter-button" variant="light" size="sm" @click="addRule" v-b-tooltip.hover.bottom :title="labels.addRule"><base-icon name="add" /></b-button>
						<b-button v-if="depth < maxDepth" size="sm" class="ml-1 filter-button" variant="light" @click="addGroup" v-b-tooltip.hover.bottom :title="labels.addGroup"><base-icon name="logic" /></b-button>
						<b-button v-if="depth > 1" size="sm" class="ml-1 filter-button" variant="light" @click="remove" v-b-tooltip.hover.bottom :title="labels.removeGroup"><base-icon name="clear" /></b-button>
					</b-col>

					
					</b-row>
				</div>
			</div>
			<query-builder-children class="ml-2" v-bind="$props" />

		</div>
	</template>

<script>
import QueryBuilderGroup from '../../components/QueryBuilderGroup';
import QueryBuilderRule from './BootstrapRule.vue';

export default {
	name: "QueryBuilderGroup",

	components: {
		// eslint-disable-next-line vue/no-unused-components
		'QueryBuilderRule': QueryBuilderRule
	},

	extends: QueryBuilderGroup,
}
</script>

<style>
	.vue-query-builder .vqb-group .rule-actions {
		margin-bottom: 10px;
	}

	.vue-query-builder .vqb-rule, .vqb-group .card-header
	{
		background-color: var(--bft-blue-50);
		border-bottom: 1px solid var(--bft-blue-200);
	}

	.vue-query-builder .card
	{
		border-color: var(--bft-blue-200);
	}

	.vue-query-builder .vqb-rule {
		margin-top: 5px;
		margin-bottom: 5px;
		border-color: var(--bft-blue-200);
		padding-top: 5px;
		padding-bottom: 5px;
		padding-left: 10px;
		padding-right: 10px;
	}

	.depth-1 > .card-header
	{
		padding-left: 60px;
		padding-right: 20px;
	}

	.vqb-group.depth-1 .vqb-rule
	{
		padding-left: 45px;
		padding-right: 20px;
	}

	.depth-2 > .card-header
	{
		padding-left: 45px;
	}

	.vqb-group.depth-2 .vqb-rule
	{
		padding-left: 30px;
	}

	.depth-3 > .card-header
	{
		padding-left: 30px;
	}

	.vqb-group.depth-3 .vqb-rule
	{
		padding-left: 15px;
	}

	.vue-query-builder .vqb-group.depth-1 .vqb-rule,
	.vue-query-builder .vqb-group.depth-2 {
		border-left: 5px solid #8bc34a;
	}

	.vue-query-builder .vqb-group.depth-2 .vqb-rule,
	.vue-query-builder .vqb-group.depth-3 {
		border-left: 5px solid #00bcd4;
	}

	.vue-query-builder .vqb-group.depth-3 .vqb-rule,
	.vue-query-builder .vqb-group.depth-4 {
		border-left: 5px solid #ff5722;
	}

	.vue-query-builder .close {
		opacity: 1;
		color: rgb(150,150,150);
	}

	@media (min-width: 768px) {
		.vue-query-builder .vqb-rule.form-inline .form-group {
			display: block;
		}
	}
</style>
